import { Component } from "@angular/core";
import { LogExport } from "@interfaces/logExport.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "exportLogs",
	styleUrls: ["exportLogs.css"],
	templateUrl: "exportLogs.html"
})
export class ExportLogsAdminComponent {
	canExportGrid = false;
	gridLoading = false;
	itemType = "Export Log"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	people: UserProfile[] = [];
	title: string;
	
	constructor(private toastService: ToastService, private itemService: ExportLogService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService) {
		this.title = `${this.itemType}s`;
		this.getItems();
		this.getPeople();
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Export Logs")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	getPeople() {
		this.userProfileService.getAllWithUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Export Logs";
		this.itemService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}
}